<template>
  <div v-if="getProductDetail.product_images">
    <!-- <Slick v-viewer
      ref='slick'
      :options='slickOptions'>
      <div v-for='image in getProductDetail.product_images' :key='image.id'>
        <img :src='formatImagePath(image.image_path, "350")' class='image' :key='image.image_path'>
      </div>
    </Slick> -->

    <v-touch v-on:swipeleft="next()" v-on:swiperight="prev()">
      <slider
        ref="slider"
        animation="fade"
        v-bind:auto="false"
        v-bind:height="calculateSlideContainerSize() + 'px'"
        v-bind:indicators="false"
      >
        <slider-item v-for="(image, index) in getProductDetail.product_images" v-bind:key="index">
          <div class="slider-images-container" v-on:click="show(index)">
            <img
              v-bind:src="formatImagePath(image.image_path, calculateSlideImageSize())"
              class="image" v-bind:class="{ 'slider-image-full': calculateSlideImageSize() < 500 }"
              v-bind:key="image.image_path"
            >
          </div>
        </slider-item>
      </slider>
    </v-touch>

    <viewer
      v-show="false"
      v-bind:options="viewerOptions"
      v-bind:images="getProductDetail.product_images"
      v-on:inited="inited"
      class="viewer" ref="viewer"
    >
      <template slot-scope="scope">
        <div v-for="(image, index) in scope.images" :key="index">
          <img
            v-bind:src="formatImagePath(image.image_path, '500')"
            class="image"
            v-bind:key="image.image_path">
        </div>
      </template>
    </viewer>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import { Slider, SliderItem } from 'vue-easy-slider'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer/src/component.vue'

export default {
  name: 'ImageSlider',
  components: {
    Slider,
    SliderItem,
    Viewer
  },
  data () {
    return {
      viewerOptions: {
        toolbar: false
      }
    }
  },
  computed: {
    ...mapGetters([
      'getProductDetail'
    ])
  },
  methods: {
    next () {
      this.$refs.slider.next()
    },
    prev () {
      this.$refs.slider.prev()
    },
    inited (viewer) {
      this.$viewer = viewer
    },
    show (index) {
      this.$viewer.view(index)
    },
    formatImagePath (image, size) {
      return process.env.IMAGE_SERVICE_URL + '/image/' + size + 'x0/' + image
    },
    calculateSlideContainerSize () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return window.innerWidth - 28
      } else {
        return 500
      }
    },
    calculateSlideImageSize () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 350
      } else {
        return 500
      }
    }
  }
}
</script>
<style type='text/css' lang='scss'>
.slider-images-container {
  width: 100%;
  text-align: center;

  .slider-image-full {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shopCategory/productDetail/imageSlider.vue